import script from "./MediaSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaSection.vue?vue&type=script&setup=true&lang=ts"

import "./MediaSection.vue?vue&type=style&index=0&id=797dd586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-797dd586"]])

export default __exports__